import cx from "classnames";
import { MDBCol, MDBContainer, MDBRow, MDBSpinner } from "mdbreact";
import moment from "moment";
import React, { Fragment, useEffect, useState } from "react";
import Loadable from "react-loadable";
import ReactMarkdown from "react-markdown";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import styles from "./style.module.scss";
import AppId from "~/utils/partner";
import { Page404 } from "~/components/common/molecules/Page404";
const NewsSame = Loadable({
  loader: () => import("../../molecules/NewsSame"),
  loading: LoadableLoading
});

const PostRelated = Loadable({
  loader: () => import("../../molecules/PostRelated"),
  loading: LoadableLoading
});

const isHtml = require("is-html");
const apiNews = "https://cms.medpro.com.vn";

export const NewsDetail = props => {
  const [post, setpost] = useState();
  const [loading, setloading] = useState(false);

  useEffect(() => {
    const getData = async () => {
      setloading(true);
      const url = apiNews + "/posts?slug=" + props.match.params.slug;
      const data = await fetch(url);
      const rs = await data.json();
      const detail = rs[0];
      if (detail?.partners?.includes(AppId)) {
        setpost(detail);
      }
      setloading(false);
    };
    getData();
  }, [props.match.params.slug]);

  if (loading) {
    return (
      <div className="loading">
        <MDBSpinner big />
      </div>
    );
  }
  if (!post) {
    return <Page404 />;
  }

  return (
    <Fragment>
      <MDBContainer className="mt-5">
        <MDBRow className="">
          <MDBCol md="8" className="mb-4">
            <Content {...post} />
          </MDBCol>

          <MDBCol md="4">
            <NewsSame />
          </MDBCol>
        </MDBRow>

        <PostRelated />
      </MDBContainer>
    </Fragment>
  );
};

export const Content = post => {
  return (
    <MDBContainer className="p-0">
      <MDBRow>
        <MDBCol>
          <h2 className="text-uppercase font-weight-bolder h3-responsive">
            {post.title}
          </h2>
        </MDBCol>
      </MDBRow>

      <MDBRow>
        <MDBCol>
          <p>
            <em>
              {moment(post?.update_at).format("DD/MM/YYYY hh:mm")} bởi{" "}
              <strong>{post?.author}</strong>
            </em>
          </p>
        </MDBCol>
      </MDBRow>

      <MDBRow className={post?.description ? "" : " d-none"}>
        <MDBCol className="text-justify">
          <blockquote>{checkContent(post?.description)}</blockquote>
        </MDBCol>
      </MDBRow>

      <MDBRow className={cx(styles.content, post?.content ? "" : " d-none")}>
        <MDBCol>{checkContent(post?.content)}</MDBCol>
      </MDBRow>

      <MDBRow>
        <MDBCol>
          <p className="h5 text-right">
            <strong>{post?.author}</strong>
          </p>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
  );
};

const checkContent = content => {
  const replaceContent = content?.replace(
    /\/uploads\//g,
    `${apiNews}/uploads/`
  );
  return (
    <Fragment>
      {isHtml(content) ? (
        <div dangerouslySetInnerHTML={{ __html: content }} />
      ) : (
        <ReactMarkdown source={replaceContent} />
      )}
    </Fragment>
  );
};
